import { Protocolo } from './protocolo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';
import { Protocol } from '_debugger';
import { ProtocoloAtendimentoTipoComponent } from '../protocolo-atendimento-tipo/protocolo-atendimento-tipo.component';
import { OrdemServico, OSServicos, OSEstados } from '../ordem-servico/ordem-servico.model';

@Injectable()
export class ProtocoloService {

    constructor(private http: Http){
    }

    getProtocolos(): Observable<Protocolo[]> {
        return this.http.get(`${NTECH_API}/protocolo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getProtocoloById(id: string): Observable<Protocolo> {
        return this.http.get(`${NTECH_API}/protocolo/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    gravarOsAtendimento(protocolo: Protocolo): Observable<OrdemServico> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        // Criando Obj OS Atendimento
        const JsonOSAtendimento = new OrdemServico;
        JsonOSAtendimento.DtHrCadastro = new Date();
        JsonOSAtendimento.IdProtocolo = protocolo.Id;
        JsonOSAtendimento.DescricaoSolicitacao = 'OS Gerada pelo Protocolo ' + protocolo.Id;
        JsonOSAtendimento.OrdemServicoTipo = 'Atendimento';
        JsonOSAtendimento.VisitaImprodutiva = 'N';
        JsonOSAtendimento.OSEstados = [];
        JsonOSAtendimento.IdEquipe = null;

        let AxOsEstado = new OSEstados();
        AxOsEstado.DtHrOSEstado = new Date();
        AxOsEstado.IdEstadosAndamento = 1;
        JsonOSAtendimento.OSEstados.push(AxOsEstado);

        AxOsEstado = new OSEstados();
        AxOsEstado.DtHrOSEstado = new Date();
        AxOsEstado.DtHrOSEstado.setSeconds(AxOsEstado.DtHrOSEstado.getSeconds() + 1);
        AxOsEstado.IdEstadosAndamento = 2;
        JsonOSAtendimento.OSEstados.push(AxOsEstado);

        // Percorrer todos os servicos do protocolo para adicionar na OS
        for ( let i = 0 ; i < protocolo.ProtocoloServico.length ; i ++) {
            const AxOsAtendimentoServico = new OSServicos;

            AxOsAtendimentoServico.IdServicoSolicitacao = protocolo.ProtocoloServico[i].IdServico;
            AxOsAtendimentoServico.IdServicoExecucao = null;
            AxOsAtendimentoServico.IdPessoa = null;
            AxOsAtendimentoServico.TempoExecucao = null;
            AxOsAtendimentoServico.SolucionavelAtendimento = null;
            AxOsAtendimentoServico.OSPontos = [];
            AxOsAtendimentoServico.OSItens = [];

            JsonOSAtendimento.OSServicos.push(AxOsAtendimentoServico);
        }

        // Enviar novo OSAtendimento
        return this.http.post(`${NTECH_API}/ordem-servico`,
            JSON.stringify(JsonOSAtendimento), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
    }

    gravarProtocoloSistema(protocolo: Protocolo): Observable<Protocolo> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        if ((protocolo.Id !== null) && (protocolo.Id !== undefined) && (protocolo.Id > 0)) {
            return this.http.put(`${NTECH_API}/protocolo/${protocolo.Id}`,
               JSON.stringify(protocolo), new RequestOptions({headers: headers}))
            .map(response => {
                if ( protocolo.ProtocoloServico.length > 0 ) {
                    this.gravarOsAtendimento(protocolo).subscribe(responseGravarOs => {
                        return response.json();
                    });
                } else {
                    return response.json();
                }

            })
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/protocolo`, JSON.stringify(protocolo), new RequestOptions({headers: headers}))
            .map(response => {
                if ( protocolo.ProtocoloServico.length > 0 ) {
                    this.gravarOsAtendimento(protocolo).subscribe(responseGravarOs => {
                        return response.json();
                    });
                } else {
                    return response.json();
                }
            })
            .catch(ErrorHandler.handleError);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/protocolo/protocolo.service.ts